import { useMemo } from 'react';
import { TableRow } from '../types';
import { LOAD_TABLE_FIELDS } from '../constants/table_fields';
import { AvailableModel } from '../../../api/prediction-engine';

const isDateValid = (dateString: string, limitDate: string): boolean => {
  if (!dateString || !limitDate) return true;
  return new Date(dateString) >= new Date(limitDate);
};

export const useReleaseDateValidation = (tableData: TableRow[], selectedModel: AvailableModel | null) => {
  const releaseDateErrors = useMemo(() => {
    if (!selectedModel?.predicting_limit_date) return {};
    
    const errors: { [key: number]: boolean } = {};
    tableData.forEach((row, index) => {
      const releaseDate = row[LOAD_TABLE_FIELDS.release_date] as string;
      if (releaseDate && !isDateValid(releaseDate, selectedModel.predicting_limit_date)) {
        errors[index] = true;
      }
    });
    return errors;
  }, [tableData, selectedModel?.predicting_limit_date]);

  const hasValidationErrors = Object.keys(releaseDateErrors).length > 0;

  return { releaseDateErrors, hasValidationErrors };
};